import { defaultLocale, locales } from './config'

/**
 * Matches non-default-locale URL prefixes (/es, /fr and their subpaths),
 * anchored so lookalikes (/essay) don't match. Single source of truth for
 * both the i18n request config and the middleware allowlist — add a locale
 * to lib/i18n/config.ts and both pick it up.
 */
export const LOCALE_PREFIX_RE = new RegExp(
  `^/(${locales.filter((l) => l !== defaultLocale).join('|')})(/|$)`
)

/** Locale-prefixed URL for a marketing page ('/' or '/pricing'). */
export function localizedPath(locale: string, marketingPath: string): string {
  if (locale === defaultLocale) return marketingPath
  return marketingPath === '/' ? `/${locale}` : `/${locale}${marketingPath}`
}
